import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "s-bts tjbj",
  style: {
    "justify-content": "flex-start"
  }
};
const _hoisted_2 = {
  class: "l-button btcz"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "block"
};
import { reactive, ref, getCurrentInstance, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import { exportlist } from '../../utils/lc';
import { ElLoading } from 'element-plus';
// 基本信息组件值

export default {
  __name: 'specialPromotion',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    //搜索
    let searchdata = reactive({
      type: '',
      //类型 1=停产促销,2=仅第三方仓促销,3=不停产促销,4=战略产品特价
      sku: '',
      //sku
      name: '',
      //名称
      cate_id: '',
      //产品分类
      status: -1,
      //状态 0=未生效,1=生效中,2=强制生效,3=已失效
      stock_status: -1,
      // 库存变现状态
      promotion_sn: '',
      // 编号
      depart: '',
      // 部门
      page: 1,
      size: 50
    });
    const apiVersion = process.env.VUE_APP_API_VERSION.replace(/\./g, '_');
    const baseUrl = process.env.VUE_APP_API_BASEURL + apiVersion + '/';
    const data = reactive({
      auth_write: 0,
      // 新增编辑权限1是显示
      mbfile: '',
      upLoadUrl: baseUrl + 'promotion/import',
      prlistTtable: [],
      total: 0,
      catelist: [],
      //产品分类
      typelist: [{
        label: '停产促销',
        value: 1
      }, {
        label: '仅第三方仓促销',
        value: 2
      }, {
        label: '不停产促销',
        value: 3
      }, {
        label: '战略产品特价',
        value: 4
      }],
      //分类下拉
      statelist: [{
        label: '全部',
        value: -1
      }, {
        label: '生效中',
        value: 1
      }, {
        label: '未生效',
        value: 0
      }, {
        label: '已失效',
        value: 4
      }, {
        label: '强制生效',
        value: 2
      }, {
        label: '强制失效',
        value: 3
      }],
      //库存状态下拉
      inventorystatuslist: [{
        label: '全部',
        value: -1
      }, {
        label: '未生效',
        value: 0
      }, {
        label: '生效中',
        value: 1
      }, {
        label: '已失效',
        value: 2
      }],
      cateprops: {
        expandTrigger: 'hover',
        value: 'id',
        label: 'name',
        children: 'children',
        emitPath: false
      }
    });
    /* 初始化 */
    const keyDown = e => {
      if (e.keyCode == 13 || e.keyCode == 100) {
        searchhandle();
      }
    };
    onMounted(() => {
      getcatelist();
      // 获取列表数据
      getlist();
      //绑定监听事件
      window.addEventListener('keydown', keyDown);
    });
    onUnmounted(() => {
      //销毁事件
      window.removeEventListener('keydown', keyDown, false);
    });
    /* 方法层 */
    let router = useRouter();
    //获取列表数据
    function getcatelist() {
      // 产品分类 - 集合
      proxy.$http.showLoading(true).get('v1/category', {
        language_id: 1
      }).then(res => {
        if (res.status == 200) {
          data.catelist = res.data;
        }
      });
    }
    function getlist() {
      let sudata = JSON.parse(JSON.stringify(searchdata));
      sudata.type = sudata.type ? sudata.type : -1;
      proxy.$http.showLoading(true).get('promotion/list', sudata).then(res => {
        if (res.errno == 200) {
          data.mbfile = res.data.import_file_url;
          data.prlistTtable = res.data.list.data;
          data.total = res.data.list.total;
          data.auth_write = res.data.auth_write;
        }
      });
    }
    const store = useStore();
    //下载模板
    function xzmb() {
      // 假设这是你要下载的文件的URL  
      const fileUrl = data.mbfile;

      // 创建一个a标签  
      const link = document.createElement('a');
      link.href = fileUrl;
      // 设置下载后的文件名（可选，如果服务器响应中包含了正确的Content-Disposition头，则可能不需要）  
      link.setAttribute('download', 'desiredFileName.pdf');

      // 兼容性处理：模拟点击需要添加到document中  
      document.body.appendChild(link);
      link.click();

      // 清理：移除a标签（可选，但推荐）  
      document.body.removeChild(link);
    }
    // 跳转新增编辑
    function jumpPage(type, id) {
      if (type == 'add') {
        router.push({
          path: '/index/addspeciapr'
        });
      }
      if (type == 'edit') {
        // 关闭页签 如果存在 editSpu 先关闭
        let index = null;
        store.state.topNavTag.tags.forEach((el, inde) => {
          el.fullPath.indexOf('editspeciapr') != -1 ? index = inde : false;
        });
        if (index) {
          store.dispatch('topNavTag/removeNavTag', index);
        }
        router.push({
          path: '/index/editspeciapr',
          query: {
            id: id
          }
        });
      }
    }
    //重置
    function resetSearch() {
      getcatelist();
      proxy.$refs.searchform.resetFields();
      getlist();
    }
    // 搜索
    function searchhandle() {
      getlist();
    }

    //分页条数
    function handleSizeChange(val) {
      searchdata.size = val;
      searchdata.page = 1;
      getlist();
    }

    //分页数
    function handleCurrentChange(val) {
      searchdata.page = val;
      getlist();
    }
    const checklist = ref([]);

    // 导出
    function exportOut() {
      let query = {
        page: searchdata.page,
        type: searchdata.type ? searchdata.type : -1,
        sku: searchdata.sku,
        name: searchdata.name,
        cate_id: searchdata.cate_id || '',
        status: searchdata.status ? searchdata.status : -1,
        path: '/promotion/export',
        ids: checklist.value.length == 0 ? '' : checklist.value.join()
      };
      exportlist(null, null, null, null, '导出', query);
    }
    // 强制失效 强制生效
    function isiteffective(type) {
      if (checklist.value.length == 0) {
        ElMessage({
          type: 'error',
          message: type == 'loseefficacy' ? '请先勾选在操作强制失效!' : '请先勾选在操作强制生效!'
        });
        return;
      }
      proxy.$http.showLoading(true).post('promotion/editBatch', {
        ids: checklist.value.join(),
        status: type == 'loseefficacy' ? 3 : 2
      }).then(res => {
        if (res.errno == 200) {
          ElMessage.success(`${type == 'loseefficacy' ? '强制失效' : '强制生效'}操作成功!`);
          resetSearch();
        } else {
          ElMessage.error(res.errmsg);
        }
      });
    }
    //导入
    let loadingInstance = ref();
    function handleSuccess(res) {
      if (res.errno == 200) {
        resetSearch();
        ElMessage.success(res.errmsg);
      } else {
        ElMessage.error(res.errmsg);
      }
      proxy.$refs.uploadwlbj.clearFiles();
      loadingInstance.value.close();
    }
    //文件校验方法
    function beforeAvatarUpload(file) {
      loadingInstance.value = ElLoading.service({
        lock: true,
        text: '此操作需要一段时间请耐心等待！',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      //不能导入大小超过20Mb的文件
      if (file.size > 20 * 1024 * 1024) {
        ElMessage({
          type: 'error',
          message: '文件过大，请上传小于20MB的文件!'
        });
        loadingInstance.value.close();
        return false;
      }
      return true;
    }
    // 列表单选
    function selectionChange(val) {
      checklist.value = val.records.map(it => {
        return it.id;
      });
    }
    // 列表全选
    function selectionallChange(val) {
      checklist.value = val.records.map(it => {
        return it.id;
      });
    }
    // 库存数据刷新
    function syncInventoryData() {
      proxy.$http.showLoading(true).post('promotion/syncStock').then(res => {
        if (res.errno == 200) {
          ElMessage.success(res.errmsg);
          resetSearch();
        } else {
          ElMessage.error(res.errmsg);
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_cascader = _resolveComponent("el-cascader");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_arrow_down = _resolveComponent("arrow-down");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lcpg"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(searchdata),
          ref: "searchform"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "类型",
                prop: "type"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(searchdata).type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(searchdata).type = $event),
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.typelist, it => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: it.value,
                      label: it.label,
                      key: it.value
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 3
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "规格型号(SKU)",
                prop: "sku"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(searchdata).sku,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(searchdata).sku = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 3,
              style: {
                "margin-left": "5%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "产品名称",
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(searchdata).name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(searchdata).name = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 4,
              style: {
                "margin-left": "3%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "产品分类",
                prop: "cate_id"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_cascader, {
                  disabled: data.isDisabled,
                  modelValue: _unref(searchdata).cate_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(searchdata).cate_id = $event),
                  "show-all-levels": false,
                  clearable: "",
                  options: data.catelist,
                  props: data.cateprops
                }, null, 8, ["disabled", "modelValue", "options", "props"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "特价状态",
                prop: "status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(searchdata).status,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(searchdata).status = $event),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.statelist, it => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: it.value,
                      label: it.label,
                      key: it.value
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "库存变现状态",
                prop: "stock_status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(searchdata).stock_status,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(searchdata).stock_status = $event),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.inventorystatuslist, it => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: it.value,
                      label: it.label,
                      key: it.value
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "编号",
                prop: "promotion_sn"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(searchdata).promotion_sn,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(searchdata).promotion_sn = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 4
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "部门",
                prop: "depart"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(searchdata).depart,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(searchdata).depart = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [_createElementVNode("div", {
                  class: "s-bts"
                }, [_createElementVNode("div", {
                  class: "l-button",
                  onClick: searchhandle
                }, "搜索"), _createElementVNode("div", {
                  class: "l-button",
                  onClick: resetSearch
                }, "重置")])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [data.auth_write == 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "l-button",
          style: {
            "margin-right": "10px"
          },
          onClick: _cache[8] || (_cache[8] = $event => jumpPage('add'))
        }, "新增")) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
          "hide-on-click": false
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [data.auth_write == 1 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 0,
              onClick: xzmb
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("下载模板")])),
              _: 1,
              __: [12]
            })) : _createCommentVNode("", true), data.auth_write == 1 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 1,
              onClick: _ctx.exportIn
            }, {
              default: _withCtx(() => [_createVNode(_component_el_upload, {
                action: data.upLoadUrl,
                "with-credentials": true,
                "on-success": handleSuccess,
                "show-file-list": false,
                name: "file",
                limit: 1,
                accept: ".xls,.xlsx",
                "before-upload": beforeAvatarUpload,
                ref: "uploadwlbj"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("div", null, "导入", -1)])),
                _: 1,
                __: [13]
              }, 8, ["action"])]),
              _: 1
            }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
              onClick: exportOut
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("导出")])),
              _: 1,
              __: [14]
            }), data.auth_write == 1 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 2,
              onClick: _cache[9] || (_cache[9] = $event => isiteffective('loseefficacy'))
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("强制失效")])),
              _: 1,
              __: [15]
            })) : _createCommentVNode("", true), data.auth_write == 1 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 3,
              onClick: _cache[10] || (_cache[10] = $event => isiteffective('takeeffect'))
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("强制生效")])),
              _: 1,
              __: [16]
            })) : _createCommentVNode("", true), data.auth_write == 1 ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: 4,
              onClick: syncInventoryData
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("库存数据刷新")])),
              _: 1,
              __: [17]
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[11] || (_cache[11] = _createTextVNode("操作")), _createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_arrow_down)]),
            _: 1
          })])]),
          _: 1
        })]), _createElementVNode("div", null, [_createVNode(_component_vxe_table, {
          onCheckboxChange: selectionChange,
          onCheckboxAll: selectionallChange,
          "max-height": "620",
          border: "",
          "show-overflow": "",
          data: data.prlistTtable,
          class: "ggdycss"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            type: "checkbox",
            width: "40",
            fixed: "left"
          }), _createVNode(_component_vxe_column, {
            field: "promotion_sn",
            title: "编号",
            width: "150",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "depart",
            title: "部门",
            width: "180",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "type",
            title: "类型",
            width: "110",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "sku",
            title: "规格型号(SKU)",
            width: "225",
            align: "left",
            fixed: "left"
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", {
              onClick: $event => jumpPage('edit', row.id),
              style: {
                "color": "#409eff",
                "cursor": "pointer"
              }
            }, _toDisplayString(row.sku), 9, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "name",
            title: "名称",
            width: "200",
            align: "left",
            fixed: "left"
          }), _createVNode(_component_vxe_column, {
            field: "cate_name",
            title: "产品分类",
            width: "250",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "stock_status",
            title: "库存变现状态",
            width: "95",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "stock_start_time",
            title: "库存变现生效日期",
            width: "95",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "stock_end_time",
            title: "库存变现失效日期",
            width: "95",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "factory_price",
            title: "出厂价",
            width: "90",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "price",
            title: "清库核算价格/清库特价",
            width: "90",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "discount",
            title: "清库折扣力度",
            width: "95",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "domestic_retail_price",
            title: "建议国内零售限价(￥)",
            width: "85",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "overseas_retail_price",
            title: "建议海外零售限价($)",
            width: "85",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "total_stock",
            title: "成品仓库存总量",
            width: "70",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_cd",
            title: "ORICO-CD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_od",
            title: "ORICO-OD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_ad",
            title: "ORICO-AD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_bd",
            title: "ORICO-BD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_fd",
            title: "ORICO-FD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_gd",
            title: "ORICO-GD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_hd",
            title: "ORICO-HD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "orico_jd",
            title: "ORICO-JD库存",
            width: "65",
            align: "right"
          }), _createVNode(_component_vxe_column, {
            field: "status",
            title: "特价状态",
            width: "80",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "start_time",
            title: "特价生效日期",
            width: "95",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "end_time",
            title: "特价失效日期",
            width: "95",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "create_time",
            title: "创建日期",
            width: "140",
            align: "center"
          }), _createVNode(_component_vxe_column, {
            field: "update_time",
            title: "最后更新日期",
            width: "140",
            align: "center"
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_pagination, {
          background: "",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(searchdata).page,
          "page-sizes": [50, 100, 150],
          "page-size": _unref(searchdata).size,
          layout: "total, sizes, prev, pager, next, jumper",
          total: data.total
        }, null, 8, ["current-page", "page-size", "total"])])])]),
        _: 1
      });
    };
  }
};